// API Configuration - Pure Vercel Serverless
const API_URL = process.env.REACT_APP_API_URL || '/api';

export const API_ENDPOINTS = {
  REGISTER: `${API_URL}/register`,
  LOGIN: `${API_URL}/login`,
  PROFILE: `${API_URL}/profile`,
  SUBSCRIPTION: `${API_URL}/subscription`,
  PASSWORD_CHANGE: `${API_URL}/change-password`,
  HELLO: `${API_URL}/hello`, // Test endpoint
  TEST_ACCESS: `${API_URL}/test-access`,
  RECENT_TESTS: `${API_URL}/recent-tests`,
  TEST_PROGRESS: `${API_URL}/test-progress`,
  QUESTION_ATTEMPTS: `${API_URL}/question-attempts`,
  WEAK_QUESTIONS: `${API_URL}/weak-questions`,
};

export default API_URL;
